import { render, staticRenderFns } from "./TopicInput.vue?vue&type=template&id=4d21a252&scoped=true&"
import script from "./TopicInput.vue?vue&type=script&lang=js&"
export * from "./TopicInput.vue?vue&type=script&lang=js&"
import style0 from "./TopicInput.vue?vue&type=style&index=0&id=4d21a252&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d21a252",
  null
  
)

export default component.exports